import {TiberEnvironmentProvider} from ".";

export class ProductionEnvironment extends TiberEnvironmentProvider {
    production = true
};
